import React from 'react';
import classnames from 'classnames';
import { Spinner } from 'reactstrap';
import './index.scss';

export interface ILoadingProps {
  pageLevel?: boolean;
  inline?: boolean;
  color?: string;
  size?: number;
}

const Loading: React.FC<ILoadingProps> = ({ pageLevel, inline, color, size }) => {
  const props: any = { color };
  if (pageLevel) {
    props.style = { width: '10rem', height: '10rem' };
  }

  if (size) {
    props.style = { width: `${size}rem`, height: `${size}rem` };
  }

  return (
    <div className={classnames('loading_container', { inline })}>
      <div
        className={classnames('loading', {
          page_level: pageLevel,
        })}>
        <Spinner {...props} />
      </div>
    </div>
  );
};

export default Loading;
